export default {
  "product": {
    "product:autoMachineLearning": "Auto Machine Learning Platform",
    "product:modelDeployment": "AILM: Model Deployment",
    "product:anomalyDetection": "Anomaly Detection",
    "product:knowledgeManagement": "AILM: Knowledge Management",
    "product:adminService": "Admin Service",
    "product:onlineDeployment": "Online Deployment"
  },
  common: {
    profetAI: '杰倫智能科技',
    welcome: '歡迎登入',
    username: '使用者名稱',
    onlineUsers: '在線的使用者',
    password: '密碼',
    login: '登入',
    submit: '提交',
    resetPassword: '請重置密碼',
    newPassword: '新密碼',
    confirmPassword: '請確認新密碼',
    changeSucceeded: '更改成功，請重新登入',
  }, // common
  validate: {
    isRequired: '{0} 不得為空',
    notEqual: '密碼不一致，請確認兩次密碼相同',
    passValid: '密碼需包含至少一個小寫字母 [a-z]一個大寫字母 [A-Z]一個數字 [0-9]且至少十個字元',
  }, // validate
  warning: {
    networkErr: '請檢查網路連線環境是否順暢',
  }, // warning
  serviceQuotaNotEnough: '使用者可用額度不足，請聯絡系統管理員。',
  cannotConnectLicenseServer: '無法連線至授權伺服器，請檢查相關網路設定。',
  dbWrong: "資料庫異常",
  WrongUserNameOrPassword: "請輸入正確的使用者帳號與密碼",
  AccountIsDisabled: "{0} 此帳號已停用，請聯繫系統管理員",
  RequiredPasswordChange: "請設定新密碼",
  RequireAccountAndPassword: "使用者名稱與密碼不得為空",
  NeedAdminRole: "請聯繫系統管理員",
  userNotFound: "找不到此使用者",
  UnableToFindLicenseServer: "找不到授權伺服器位置",
  UnableToFindTargetAccountService: "找不到使用者帳號/目標服務",
  PasswordExpired: "密碼已過期，請重新設定密碼",
}